import React from 'react'
import propTypes from 'prop-types'

import { FnaProvider } from './context'
import { Card } from '../../components/layout/Card'
import { Views } from './Views'
import { Header } from './Components/Header'

export const FNA = (props) => {
  return (
    <FnaProvider {...props}>
      <Card>
        <Header />
        <Views />
      </Card>
    </FnaProvider>
  )
}

FNA.propTypes = {
  supportedCurrencies: propTypes.object.isRequired,
  assets: propTypes.arrayOf(propTypes.object).isRequired,
  liabilities: propTypes.arrayOf(propTypes.object).isRequired,
  riskProducts: propTypes.arrayOf(propTypes.object).isRequired,
  scenarioPlanningPath: propTypes.string,
  budget: propTypes.object.isRequired,
  fna: propTypes.object.isRequired,
  crudActions: propTypes.object.isRequired,
  filter: propTypes.func
}
